import { render, staticRenderFns } from "./ModalNew.vue?vue&type=template&id=467e86df&"
import script from "./ModalNew.vue?vue&type=script&lang=js&"
export * from "./ModalNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports